import React from 'react';
import "./Material.css";

function Material() {
  return (
    <div className='material-container'>
      <div className="material-content">

        <div className='material-header'>
          <h3>MALZEME GELİŞTİRME</h3>
        </div>
        <div className='pro-text-promotion'>
          <h3>MALZEME GELİŞTİRME</h3>
          <p>Son teknoloji üretim ekipmanlarımız ile ihtiyaçlarınıza göre malzeme tasarlanır.</p>
          <p>Tasarlanan hamur reçetesi Werner&Pfleiderer 2,8 L Banbury ile prototip halinde üretilir.</p>
          <p>Malzemenin mekanik özellikleri, dolgu dispersiyonu, düşük sıcaklıkta davranışı, alev dayanımı, ozon dayanımı gibi testler uluslararası standartlara uygun olarak laboratuvarımızda gerçekleştirilir.</p>

        </div>



        <div className='material-tablo-container'>
          <table>
            <tr>
              <th>CHEMICAL IDENTIFICATION</th>
              <th>ABBREVIATION</th>
              <th>MAIN FUTURE</th>
              <th>TEMPERATURE RANGE</th>
              <th>CHEMICAL BEHAVIOUR</th>
            </tr>
            <tr>
              <td className='td-one'>NATURAL RUBBER</td>
              <td className='nr'>NR</td>
              <td>Qustanding elasticity, fatigue resistance, shear strength and tear strength
                Excellent elongation at break </td>
              <td> -70°C      +80°C</td>
              <td>Fair resistance to sea water, acids and bases of medium concentration</td>
            </tr>
            <tr className='tr-light'>
              <td className='td-one'>POLYSOPRENE</td>
              <td className='nr'>IR</td>
              <td>High physical properties Good elasticity at low temperatures </td>
              <td> -70°C      +90°C</td>
              <td>Being chemically similar to natural rubber,it has the same limitations</td>
            </tr>
            <tr>
              <td className='td-one'>BUTADİENE STYRENE COPOLYMER</td>
              <td className='nr'>SBR</td>
              <td>General purpose, sufficiently cost effective Good resistance against brake fluids</td>
              <td> -40°C      +100°C</td>
              <td>Slightly superior to NR Good resistance against brake fluids</td>
            </tr>
            <tr className='tr-light'>
              <td className='td-one'>BUTADIENE ACRYLONITRILE COPOLYMER</td>
              <td className='nr'>NBR</td>
              <td>Qutstanding resistance to oils, heat and ageing Good mechanical properties Low compression set and low gas permeability </td>
              <td> -50°C      +130°C</td>
              <td>Mineral oils, hydrocarbons, water, vapour, gas, vegetal oils</td>
            </tr>
            <tr>
              <td className='td-one'>ETHYL ACRYLATE COPOLYMER</td>
              <td className='nr'>ACM</td>
              <td>Oil and temperature resistance superior than NBR </td>
              <td> -40°C      +165°C</td>
              <td>Aliphatic oils, heat, oxygen, ozone</td>
            </tr>
            <tr className='tr-light'>
              <td className='td-one'>HYDROGENATED NITRILE RUBBER</td>
              <td className='nr'>HNBR</td>
              <td>Excellent physical properties and abrasion resistance Good compression set Good ageing behaviour</td>
              <td> -40°C      +150°C</td>
              <td>Mineral oils, hydrocarbons, water, vapour, gas, vegetal oils</td>
            </tr>
            <tr>
              <td className='td-one'>CARBOXYLATED NITRILE RUBBER</td>
              <td className='nr'>XNBR</td>
              <td>High tensile strength, abrasion resistance and hot tear strength High adhesive bond and cohesion force </td>
              <td> -30°C      +145°C</td>
              <td>Mineral and vegetal oils, hydrocarbons, water, steam, gas</td>
            </tr>
            <tr className='tr-light'>
              <td className='td-one'>POLYCHLOROPRENE</td>
              <td className='nr'>CR</td>
              <td>Fair oil resistance Excellent resistance to ozone, sea water and ageing Good shear strength, abrasion</td>
              <td> -50°C      +120°C</td>
              <td>Petroleum derivatives, sun light and atmospheric agents, ozone, flame</td>
            </tr>
            <tr className='tr-light'>
              <td className='td-one'>CHLOROSULPHONATED POLYETHYLENE</td>
              <td className='nr'>CSM</td>
              <td>Qutstanding resistance to ozone, heat, atmospheric agents, abrasion, shear strength and flame</td>
              <td> -50°C      +160°C</td>
              <td>Qutstanding resistance to strongly oxydizing aggressive chemicals</td>
            </tr>
            <tr>
              <td className='td-one'>ISOBUTHYLENE-ISOPRENE COPOLYMER</td>
              <td className='nr'>IIR</td>
              <td>Qutstanding dielectric strength Very low gas permeability</td>
              <td> -40°C      +110°C</td>
              <td>Liquid and gaseous fluids, oxygen, ozone, light, electricity, vegetal and animal oils, acids and bases</td>
            </tr>

            <tr>
              <td className='td-one'>TETHYLENE-PROPILENE COPOLYMER</td>
              <td className='nr'>EPM</td>
              <td>Very good resistance to heat, atmospheric agents and ageing Exceptionally low brittle temperature (-94°C)</td>
              <td> -60°C      +150°C</td>
              <td>Good resistance to aggressive chemicals and to oxidation</td>
            </tr>
            <tr className='tr-light'>
              <td className='td-one'>ETHYLENE-PROPYLE-NEDIENE TERPOLYMER</td>
              <td className='nr'>EPDM</td>
              <td>Smilar to EPM</td>
              <td> -60°C      +150°C</td>
              <td>Basically similar to EPM</td>
            </tr>
            <tr>
              <td className='td-one'>ETHYLENE-VINYLACETATE COPOLYMER</td>
              <td className='nr'>EVA</td>
              <td>Good resistance to oxygen, ozone, high temperatures, water, vapour </td>
              <td>-50°C      +150°C</td>
              <td>Oxygen, ozone, high temperatures, vapour</td>
            </tr>
            <tr className='tr-light'>
              <td className='td-one'>POLYURETHANES</td>
              <td className='nr'>PU</td>
              <td>Qutstanding abrasion resistance, tensile strength, flexibility and resistance against oils </td>
              <td>-30°C      +100°C</td>
              <td>Petroleum derivatives</td>
            </tr>
            <tr>
              <td className='td-one'>POLYEPICHLOROHYDRIN</td>
              <td className='nr'>ECO</td>
              <td>very good resistance to heat, atmospheric agents and ageing  Exceptionally low brittle temperature (-94°C)</td>
              <td> -40°C      +160°C</td>
              <td>Perfect resistance to oil Qutstanding resistance to solvents, to many acids and to CFC</td>
            </tr>
            <tr className='tr-light'>
              <td className='td-one'>VAMAC</td>
              <td className='nr'>AEM</td>
              <td>Oil and heat resistance polymer
                Good balance of low temperature flexibility, weathering resistance and physical strength</td>
              <td> -30°C      +170°C</td>
              <td>Resistance aganist oils, amines, radiator fluids</td>
            </tr>

          </table>

        </div>


      </div>
    </div>
  )
}

export default Material
